/**
 * Utility functions for formatting text and names
 */

/**
 * Formats subject names by splitting underscores and capitalizing words
 * @param name - The name to format (e.g., "english_literature" or "mathematics")
 * @returns Formatted name (e.g., "English Literature" or "Mathematics")
 */
export const formatSubjectName = (name: string): string => {
  if (!name) return '';
  
  return name
    .split('_') // Split by underscore
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter of each word
    .join(' '); // Join with spaces
};

/**
 * Formats any text by splitting underscores and capitalizing words
 * Alias for formatSubjectName for broader use cases
 * @param text - The text to format
 * @returns Formatted text
 */
export const formatDisplayName = formatSubjectName;

/**
 * Capitalizes the first letter of a string
 * @param text - The text to capitalize
 * @returns Text with first letter capitalized
 */
export const capitalizeFirst = (text: string): string => {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};
